<div
  class="sub-nav-item"
  (click)="navItemSelected(); $event.stopPropagation()"
  [class.sub-active]="viewModel.isNavItemActive$ | async">
  {{ subItem?.name }}
  <span class="alert-indicator" *ngIf="viewModel.showNavItemAlertIndicator$ | async">&nbsp;</span>
</div>
